import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";


// data
import {OnlineTransactionList} from "./onlineTransactionsList-api"
//auth
import auth from "../../../auth/auth-helper";

const columns = [
  {
   name: "sourceAccount",
   label: "Source Account",
  },
  {
   name: "destinationAccount",
   label: "Destination Account",
  },
  {
    name: "amount",
    label: "Amount",
   },
  {
   name: "date_time",
   label: "Date",
  },
  {
    name: "online_transaction_id",
    label: "ID",
    options: {
      filter: true,
      sort: false,
     }
   },
  
  {
   name: "detail",
   label: "PS",
  },
  {
    name: "sourceBranch",
    label: "Source Branch",
   },
   {
    name: "destinationBranch",
    label: "Destination Branch",
   },
 ];

export default function Transactions() {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    OnlineTransactionList(signal,credentials).then((res) => {
      if (res.status === 200) {
        console.log('token here .....................'+ credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setTransactions(res.response[0]);
      } else {
       
      }
     
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Online Transactions" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Transactions List"
            data={transactions}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={mock.table} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}